export default "__VITE_ASSET__85xyH3NL__"